'use client';

import React, { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import Button from '@/ui/components/shared/Button';
import { Option } from '@/ui/components/shared/multistepFormComponents/types';
import Image from 'next/image';

export type ValueInputProps = {
  image?: string;
  unit?: string;
  startingValue: number;
  heading: string;
  subtext: string;
  button: Option;
  onSelect: (value: any) => void;
};

function ICValueInput({
  image,
  unit,
  startingValue,
  heading,
  subtext,
  button,
  onSelect,
}: Readonly<ValueInputProps>) {
  const [value, setValue] = useState(startingValue);

  return (
    <div className={twMerge('mx-auto w-full', image && 'max-w-lg')}>
      {image && (
        <Image
          src={image}
          alt={heading}
          className="mx-auto h-auto max-h-[calc(100svh-26rem)] w-full rounded-lg border border-neutral-100 object-contain md:max-h-none"
          width={600}
          height={400}
          sizes="(max-width: 1024px) 100vw, 50vw"
        />
      )}

      <div className="mt-6 text-start">
        <h2 className="text-md font-semibold">{heading}</h2>
        <p className="mt-2 text-sm text-neutral-60">{subtext}</p>
      </div>

      <div className="mt-6 flex items-center justify-center gap-5">
        <div className="flex w-1/2 items-center justify-between space-x-2 rounded-lg border border-neutral-100 p-1">
          <button
            type="button"
            className="flex h-7 w-7 items-center justify-center rounded-md bg-neutral-10 pb-1 text-2xl font-medium md:text-3xl"
            onClick={() => setValue(value - 1)}
          >
            -
          </button>
          <span className="text-lg  md:text-xl">
            {value} {unit}
          </span>
          <button
            type="button"
            className="flex h-7 w-7 items-center justify-center rounded-md bg-neutral-10 text-2xl font-medium md:text-3xl"
            onClick={() => setValue(value + 1)}
          >
            +
          </button>
        </div>
        <Button
          type="button"
          variant="yellowBlackBorder"
          className="flex h-10 w-1/2 items-center justify-center px-2 py-4"
          onClick={(e) => {
            onSelect(value);
            const target = e?.target as HTMLButtonElement;
            target?.blur(); // Remove focus after click
          }}
        >
          {button.text}
        </Button>
      </div>
    </div>
  );
}

export default ICValueInput;
